import { WeatherIconComponent } from '../Icon/WheaterIconComponent';
import type { WeatherReport } from '../api/internal-api-types';

import styles from './CurrentDayForecast.module.scss';
import { WeatherValue } from './WeatherValue';

type Props = {
	forecast: WeatherReport['days'][number];
	className?: string;
};

export function CurrentDayForecast({ forecast: { icon, precipitation, precipitationProbability, maxTemp, wind }, className }: Props) {
	return (
		<section className={className ?? ''}>
			<h2 className="heading3">Heute</h2>

			<div className={styles.section}>
				<WeatherIconComponent className={styles.icon} name={icon} />

				<div className={styles.temperature}>
					<WeatherValue {...maxTemp} separator={''} />
				</div>

				<table className={`heading4 ${styles.details}`}>
					<tbody>
						<tr>
							<th>Regen</th>
							<td>
								<WeatherValue {...precipitation} separator={''} />
							</td>
						</tr>
						<tr>
							<th>Risiko</th>
							<td>
								<WeatherValue {...precipitationProbability} separator={''} />
							</td>
						</tr>
						<tr>
							<th>Wind</th>
							<td>
								<WeatherValue {...wind} /> {wind.direction}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</section>
	);
}
